const CHANGE_RECEIVED_DATE = {
  RECEIVED_AT_EMPTY: 'Received on cannot be empty.',
  RECEIVED_AT_TODAY: 'Received on cannot be today.',
};

export { CHANGE_RECEIVED_DATE };
